<template>
  <div id="container">
    <div class="whitetext">barqulator</div>
    <div class="white darkgrey">
      <div class="greenseperator">
        <div class="Frabank_main greentext">
          <div class="Frabank_title">{{ t("Todays Turnover") }}</div>
          <div class="turnover abstand">{{ numberFilter(realTurnover) }},-</div>
          <div v-if="toBeat > 0" class="tobeat">
            {{ t("To beat") }}: {{ numberFilter(toBeat) }},-
          </div>
        </div>
      </div>

      <div class="greenseperator">
        <div>
          <div class="digit_holder">
            <div class="text_3digit">
              {{ t("Enter Barq's last 3 digits & submit") }}
            </div>
            <input
              v-model="digits"
              class="input_3digits"
              type="text"
              maxlength="3"
            />
          </div>
          <div @click="submit_3digit" class="submit_3digits">submit</div>
        </div>
      </div>

      <div class="middleText_holder">
        <div class="hellblau rect"></div>
        <div class="middleText abstand">{{ t("Offered") }}</div>
      </div>
      <div v-if="noOffer" class="calib">
        {{ t("no barqs offered for sale") }}
      </div>
      <template v-if="sellingList" class="sellingList middleText">
        <template v-for="(sell, i) in sellingList" :key="i">
          <template v-if="sell.status == 'offer'">
            <div>{{ i }} @ {{ numberFilter(sell.price) }},-</div>
          </template>
        </template>
      </template>

      <div class="middleText_holder">
        <div class="dunkelblau rect"></div>
        <div class="middleText abstand">{{ t("Approved") }}</div>
      </div>
      <div class="calib" v-if="noApproved">
        {{ t("no barqs approved for sale") }}
      </div>
      <template v-if="sellingList" class="sellingList middleText">
        <template v-for="(sell, i) in sellingList" :key="i">
          <template v-if="sell.status == 'approved'">
            <div>{{ i }} @ {{ numberFilter(sell.price) }},-</div>
          </template>
        </template>
      </template>

      <div class="middleText_holder">
        <div class="green rect"></div>
        <div class="middleText abstand">{{ t("Already sold") }}</div>
      </div>
      <div v-if="noSold" class="calib">{{ t("no barqs sold yet") }}</div>
      <template v-if="sellingList" class="sellingList middleText">
        <template v-for="(sell, i) in sellingList" :key="i">
          <template v-if="sell.status == 'sold'">
            <div>{{ i }} @ {{ numberFilter(sell.price) }} €</div>
          </template>
        </template>
      </template>
    </div>

    <div v-if="deactivate_barq == 'off'" class="deactivated">
      <div>{{ t("barqulator deactivated") }}</div>
    </div>
  </div>
</template>

<script>
// import Dict from "../../services/dict.js";
import Dict from "../../services/dict_new.js";

export default {
  name: "SellingList",
  components: {},
  props: {
    toBeat: {
      type: Number,
      default: () => 0,
    },
    totalRevenue: {
      type: Number,
      default: () => 0,
    },
    sellingPrice: {
      type: Object,
      default: () => {},
    },
    sellingList: {
      type: Object,
      default: () => {},
    },
    token: {
      type: String,
      default: () => "",
    },
    gamePhase: {
      type: Number,
      default: () => 0,
    },
    deactivate_barq: {
      type: String,
      default: () => "on",
    },
    // sampleTurnover: {
    //   type: Number,
    //   default: () => 0,
    // },
    sprache: {
      type: String,
      default: () => "english",
    },
  },
  watch: {
    // gamePhase: function (newVal) {
    // watch it
    // if (newVal == 0) {
    //   console.log("sampleTurnover added!");
    //   this.realTurnover = this.sampleTurnover;
    // } else {
    //   this.realTurnover = this.totalRevenue;
    // }
    // this.realTurnover = this.totalRevenue;
    // },
    // sampleTurnover: function (newVal) {
    //   this.realTurnover = newVal;
    // },
    totalRevenue: function (newVal) {
      this.realTurnover = newVal;
    },
    sellingList: function (newVal) {
      this.noOffer = true;
      this.noApproved = true;
      this.noSold = true;
      for (const sell in newVal) {
        switch (newVal[sell].status) {
          case "offer":
            this.noOffer = false;
            if (!this.noOffer && !this.noApproved && !this.noSold) return;
            break;
          case "approved":
            this.noApproved = false;
            if (!this.noOffer && !this.noApproved && !this.noSold) return;
            break;
          case "sold":
            this.noSold = false;
            if (!this.noOffer && !this.noApproved && !this.noSold) return;
            break;
        }
      }
    },
    // sprache: function (newVal) {
    //   this.Buch = new Dict(newVal);
    // },
  },
  emits: ["digits"],
  data() {
    return {
      // Buch: new Dict(this.sprache),
      realTurnover: 0,
      noOffer: true,
      noApproved: true,
      noSold: true,
      digits: "",
    };
  },

  methods: {
    t(word) {
      return Dict(word, this.sprache);
    },
    //FILTERS
    numberFilter(n) {
      return parseInt(n).toLocaleString("de-DE");
    },
    submit_3digit() {
      this.$emit("digits", this.digits);
      this.digits = "";
    },
  },
  created() {
    console.log("CREATED totalrevenue");
    // if (this.gamePhase == 0) {
    //   console.log("sampleTurnover added!");
    //   this.realTurnover = this.sampleTurnover;
    // } else {
    //   this.realTurnover = this.totalRevenue;
    // }
    this.realTurnover = this.totalRevenue;
    console.log(this.totalRevenue);
  },
};
</script>

<style scoped>
/* :root {
  --green: #0f7f12;
  --orange: #fc6621
} */

.calib {
  font-family: Calibri-Bold;
}

.text_3digit {
  margin-left: -10px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.digit_holder {
  display: flex;
  margin-top: 7px;
}

.submit_3digits:hover {
  cursor: pointer;
  border: 3px solid white;
  background: var(--barq-orange);
  color: white;
}

.submit_3digits {
  height: 25px;
  border: 3px solid var(--barq-orange);
  background: white;
  color: var(--barq-orange);
  width: 61px;
  font-size: 19px;
  position: relative;
  margin-left: 99px;
  padding: 0 5px;
  margin-bottom: 10px;
}

.input_3digits {
  color: var(--barq-orange);
  width: 36px;
  padding: 5px;
  border: 0px;
  font-size: 19px;
  margin-bottom: 5px;
}

.green {
  background-color: var(--barq-green);
}

.hellblau,
.lightblue {
  background-color: var(--barq-lightblue);
}

.dunkelblau,
.blue {
  background-color: var(--barq-darkblue);
}

.middleText_holder {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  text-align: end;
}

.rect {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 5px;
}

.darkgrey {
  color: #464646;
}

.deactivated > div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%) rotate(-90deg);
  width: 200%;
  text-align: center;
  font-size: 2em;
}

.deactivated {
  color: red;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  background: rgb(255 255 255 / 70%);
  backdrop-filter: blur(1px);
}

.abstand {
  margin: 20px 0;
}

.turnover {
  font-size: 20px;
  text-align: end;
}

.Frabank_title {
  font-size: 21px;
}

.middleText {
  font-size: 19px;
  width: 100%;
}

.greenseperator {
  border-bottom: 2px solid var(--barq-green);
}

.whitetext {
  color: white;
  text-align: left;
  line-height: 1.5em;
  font-size: 1.5em;
}

.greentext {
  color: var(--barq-green);
}

.white {
  height: 94%;
  background: #f2f2f2;
  border: 2px solid white;
  border-radius: 2px;
  font-size: 14px;
  padding: 0 10px;
  overflow: scroll;
}

#container:before {
  border: 2px solid white;
  content: "";
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 13px;
  pointer-events: none;
}

#container {
  background-color: var(--barq-orange);
  position: relative;
  border-radius: 20px;
  border: 6px solid white;
  padding: 1em;
  /* margin-right: 1em; */
  width: 200px;
  text-align: right;
  height: 570px;
}
</style>
